import { WIDOW_SIZE } from "@bing/engine-shelem";

/* ------------------------------------------------------------------ *
 * شلم's TABLE BEATS — how long the web table animates the two moments the engine waits for (P1
 * Task 5, R6). The engine's `postMoveDelayMs` holds the next bot move — and the game-server's
 * `scriptedBeat` the next turn window — for each of them; `packages/engines/shelem/test/pacing
 * .test.ts` IMPORTS these numbers (never a copy) and pins every engine beat at ≥ the web's hold +
 * animation + 150 ms. Plain numbers, no React and nothing but the engine's own card count, so the
 * engine's test can load this file.
 * ------------------------------------------------------------------ */

/** THE کف's PICKUP: each of the four cards flies from the felt's face-down کف (beside your partner's
 *  avatar) to the حاکم — face-up into your hand if it is you, face-down to the seat otherwise —
 *  `KAF_FLIGHT_MS` each, `KAF_STAGGER_MS` apart. */
export const KAF_FLIGHT_MS = 520;
export const KAF_STAGGER_MS = 90;
/** When the last of the four lands (its flight leaves `WIDOW_SIZE − 1` staggers in). */
export const KAF_PICKUP_LANDS_MS = (WIDOW_SIZE - 1) * KAF_STAGGER_MS + KAF_FLIGHT_MS;
/** The other seats' line «{name} زمین را برداشت» stays up this long from the pickup's frame. */
export const KAF_PICKUP_NOTICE_MS = 1300;
/** What the engine's pickup beat covers: the flight, and the line read to its end. */
export const KAF_PICKUP_MS = Math.max(KAF_PICKUP_LANDS_MS, KAF_PICKUP_NOTICE_MS);

/** The حاکم's four laid-down cards sweep, face-down, toward the حاکم's pile — inside the room's
 *  700 ms bot cadence (`BOT_MOVE_DELAY_MS`), so a bot حاکم's first card never lands on it. */
export const KAF_DISCARD_SWEEP_MS = 450;

/** THE TRUMP CALL: the حاکم's first card of trick 1 lands — `ThrownCard`'s flight, `CARD_ENTRY_MS`
 *  (`shelem-contract.test.tsx` pins the two equal: this file imports nothing from card-motion) —
 *  then «حکم: ♠ — {name}» stays `TRUMP_ANNOUNCE_MS`. */
export const LEAD_LAND_MS = 400;
export const TRUMP_ANNOUNCE_MS = 1500;
/** What the engine's announce beat covers: the card's flight, and the announce read to its end. */
export const TRUMP_ANNOUNCE_ENDS_MS = LEAD_LAND_MS + TRUMP_ANNOUNCE_MS;

/** THE HAND'S END (P1 Task 7): the 12th trick's last card deals the next hand, and its first frame
 *  carries that trick. The table holds it and collects it — `useTrickHold`'s `TRICK_HOLD_MS` +
 *  `TRICK_COLLECT_MS`, the same 950 ms every trick takes (`shelem-hand-end.test.tsx` pins the two
 *  equal: this file imports nothing from the hold, whose module is React's) — then the hand-end card
 *  is read for `HAND_END_CARD_MS`: how the contract went, the حاکم and its کف revealed, each team's
 *  points this hand. 5.5 s since card-67 C5 (the operator: «too busy and gone too fast … keep it a few seconds
 *  longer — long enough to understand what happened, not so long it drags»): 3 s until then. */
export const HAND_END_COLLECT_MS = 950;
export const HAND_END_CARD_MS = 5500;
/** What the engine's hand-end beat covers: the collect, and the card read to its end. */
export const HAND_END_ENDS_MS = HAND_END_COLLECT_MS + HAND_END_CARD_MS;
/** THE MATCH's LAST HAND drew its own 3-s card (card-67 C5) until card-98 item 11 (the operator: «No
 *  separate card before it»): the table draws NO hand-end card at the match's end, and the end card
 *  says the last hand in its own box. */
/** At the match's end the end card comes up after the last collect and 150 ms more (the shared
 *  shell's `endRevealMs`, P1 Task 7: «always shown»): 1100 ms (card-98 item 11 — 4100 ms while the
 *  3-s hand-end card came first). */
export const SHELEM_END_REVEAL_MS = HAND_END_COLLECT_MS + 150;

/** THE REDEAL (D6; the final review B-I2): three opening passes deal the hand again at once — the
 *  engine's redeal frame, which carries the three passes (`passedOut`). The table shows the third
 *  «پاس» on its seat ALONE for `REDEAL_PASS_MS` (your fan still holds the old hand: nothing is dealt
 *  before it is explained), then «سه پاس؛ دست دوباره پخش می‌شه» with the shuffle as the new hand deals
 *  in, read for `REDEAL_NOTICE_MS` — the deal-in's 945 ms and a read after it (the layout kit's
 *  settle measures the notice as the deal-in ends: `shelem-redeal.test.tsx` pins it painted then). */
export const REDEAL_PASS_MS = 400;
export const REDEAL_NOTICE_MS = 1600;
/** What the engine's redeal beat covers: the third «پاس», and the notice read to its end. */
export const REDEAL_ENDS_MS = REDEAL_PASS_MS + REDEAL_NOTICE_MS;
